import en from "./en";
import no from "./no";

const translations = { en, no };

export default translations;
